import React, { useEffect, useState } from 'react';
import { validateFunctionalForm } from '../../../utils';
import { v2_ship_owners, v2_shipTypes, v2_yards } from '../../../actions/v2/masterData';
import { v2_projects } from '../../../actions/v2/projectAndVessel';
import { v2_user_by_designations } from '../../../actions/v2/user';
import constant from '../../../constant';

const ShipForm = ({ data, onSubmit, title }) => {
    const [state, setState] = useState({
        shipName: { name: 'shipName', value: data?.SHIP_NAME || '', isRequired: false, error: '' },
        shipCode: { name: 'shipCode', value: data?.SHIP_CODE || '', isRequired: false, error: '' },
        shipType: { name: 'shipType', value: data?.SHIP_TYPE || '', isRequired: false, error: '', options: [] },
        shipOwnerId: { name: 'shipOwnerId', value: data?.SHIP_OWNER_ID || '', isRequired: false, error: '', options: [] },
        projectId: { name: 'projectId', value: data?.PROJECT_ID || '', isRequired: false, error: '', options: [] },
        yardId: { name: 'yardId', value: data?.YARD_ID || '', isRequired: false, error: '', options: [] },
        buildDate: { name: 'buildDate', value: data?.BUILD_DATE || '', isRequired: false, error: '' },
        deliveryDate: { name: 'deliveryDate', value: data?.DELIVERY_DATE || '', isRequired: false, error: '' },
        isActive: { name: 'isActive', value: data?.IS_ACTIVE ?? true, isRequired: false },
        note: { name: 'note', value: data?.NOTE || '', isRequired: false, error: '' },
        imo_number: { name: 'imo_number', value: data?.IMO_NUMBER || '', isRequired: false, error: '' },
        class_number: { name: 'class_number', value: data?.CLASS_NUMBER || '', isRequired: false, error: '' },
        technical_supritendent: { name: 'technical_supritendent', value: data?.TECHNICAL_SUPRITENDENT || '', isRequired: false, error: '', options: [] },
        unit_manager: { name: 'unit_manager', value: data?.UNIT_MANAGER || '', isRequired: false, error: '', options: [] },
        chief_engineer: { name: 'chief_engineer', value: data?.CHIEF_ENGINEER || '', isRequired: false, error: '', options: [] },
        hull_number: { name: 'hull_number', value: data?.HULL_NUMBER || '', isRequired: true, error: '' },

    });

    const setOptions = (name, options) => {
        setState(prev => ({
            ...prev,
            [name]: {
                ...prev[name],
                options: options,
            }
        }));
    };

    useEffect(() => {
        v2_ship_owners().then((res) => {
            if (res.status) {
                const options = res.result.map((item) => ({
                    label: item.OWNER_NAME,
                    value: item.ID,
                }));
                setOptions('shipOwnerId', options);
            }
        });

        v2_yards().then((res) => {
            if (res.status) {
                const options = res.result.map((item) => ({
                    label: item.YARD_NAME,
                    value: item.ID,
                }));
                setOptions('yardId', options);
            }
        });

        v2_shipTypes().then((res) => {
            if (res.status) {
                const options = res.result.map((item) => ({
                    label: item.SHIP_TYPE_NAME,
                    value: item.ID,
                }));
                setOptions('shipType', options);
            }
        });

        v2_projects().then((res) => {
            if (res.status) {
                const options = res.result.map((item) => ({
                    label: `${item.PROJECT_NAME} (${item.PROJECT_CODE})`,
                    value: item.ID,
                }));
                setOptions('projectId', options);
            }
        });


        // v2_user_by_designations(2).then((res) => {
        //     if (res.status) {
        //         const options = res.result.map((item) => ({
        //             label: item.FULL_NAME,
        //             value: item.USER_ID,
        //         }));
        //         setOptions('unit_manager', options);
        //     }
        // })
        // v2_user_by_designations(4).then((res) => {
        //     if (res.status) {
        //         const options = res.result.map((item) => ({
        //             label: item.FULL_NAME,
        //             value: item.USER_ID,
        //         }));
        //         setOptions('technical_supritendent', options);
        //     }
        // })
        // v2_user_by_designations(5).then((res) => {
        //     if (res.status) {
        //         const options = res.result.map((item) => ({
        //             label: item.FULL_NAME,
        //             value: item.USER_ID,
        //         }));
        //         setOptions('chief_engineer', options);
        //     }
        // })
    }, []);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        const val = type === 'checkbox' ? checked : value;

        setState(prev => ({
            ...prev,
            [name]: {
                ...prev[name],
                value: val,
                error: prev[name].isRequired && !val ? 'This field is required' : ''
            }
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateFunctionalForm(state, setState)) {
            const model = {};
            Object.keys(state).forEach(key => {
                model[key] = state[key].value;
            });
            if (data?.ID) model.id = data.ID;
            onSubmit(model);
        }
    };

    const handleReset = () => {
        const resetState = { ...state };
        Object.keys(resetState).forEach(key => {
            resetState[key].value = data?.[key.toUpperCase()] || (key === 'isActive' ? true : '');
            resetState[key].error = '';
        });
        setState(resetState);
    };

    return (
        <form onSubmit={handleSubmit}>
            {/* <h4 className="card-title mb-4">{title}</h4> */}
            <div className="row">
                <div className="col-md-6 mb-3">
                    <label>Vessel Name {state.shipName.isRequired && <span className='text-danger'>*</span>}</label>
                    <input
                        type="text"
                        name={state.shipName.name}
                        value={state.shipName.value}
                        onChange={handleChange}
                        placeholder="Enter vessel name"
                        className={`form-control ${state.shipName.error ? 'is-invalid' : ''}`}
                    />
                    {state.shipName.error && <div className="invalid-feedback">{state.shipName.error}</div>}
                </div>

                <div className="col-md-6 mb-3">
                    <label>Official Number {state.shipCode.isRequired && <span className='text-danger'>*</span>}</label>
                    <input
                        type="text"
                        name={state.shipCode.name}
                        value={state.shipCode.value}
                        onChange={handleChange}
                        placeholder="Enter unique official number"
                        className={`form-control ${state.shipCode.error ? 'is-invalid' : ''}`}
                    />
                    {state.shipCode.error && <div className="invalid-feedback">{state.shipCode.error}</div>}
                </div>
                <div className="col-md-6 mb-3">
                    <label>HULL Number {state.hull_number.isRequired && <span className='text-danger'>*</span>}</label>
                    <input
                        type="text"
                        name={state.hull_number.name}
                        value={state.hull_number.value}
                        onChange={handleChange}
                        placeholder="Enter HULL number"
                        className={`form-control ${state.hull_number.error ? 'is-invalid' : ''}`}
                    />
                    {state.hull_number.error && <div className="invalid-feedback">{state.hull_number.error}</div>}
                </div>
                <div className="col-md-6 mb-3">
                    <label>IMO Number {state.imo_number.isRequired && <span className='text-danger'>*</span>}</label>
                    <input
                        type="text"
                        name={state.imo_number.name}
                        value={state.imo_number.value}
                        onChange={handleChange}
                        placeholder="Enter IMO number"
                        className={`form-control ${state.imo_number.error ? 'is-invalid' : ''}`}
                    />
                    {state.imo_number.error && <div className="invalid-feedback">{state.imo_number.error}</div>}
                </div>

                <div className="col-md-6 mb-3">
                    <label>Ship Type {state.shipType.isRequired && <span className='text-danger'>*</span>}</label>
                    <select
                        name={state.shipType.name}
                        value={state.shipType.value}
                        onChange={handleChange}
                        className={`form-control ${state.shipType.error ? 'is-invalid' : ''}`}
                    >
                        <option value="">-- Select Ship Type --</option>
                        {state.shipType.options?.map(type => (
                            <option key={type.value} value={type.value}>{type.label}</option>
                        ))}
                    </select>
                    {state.shipType.error && <div className="invalid-feedback">{state.shipType.error}</div>}
                </div>

                <div className="col-md-6 mb-3">
                    <label>Call Sign {state.class_number.isRequired && <span className='text-danger'>*</span>}</label>
                    <input
                        name={state.class_number.name}
                        value={state.class_number.value}
                        onChange={handleChange}
                        placeholder="Enter call sign"
                        className="form-control"
                    />
                    {state.class_number.error && <div className="invalid-feedback">{state.class_number.error}</div>}

                </div>
                {/* <div className="col-md-6 mb-3">
                    <label>Chief Engineer {state.chief_engineer.isRequired && <span className='text-danger'>*</span>}</label>
                    <select
                        name={state.chief_engineer.name}
                        value={state.chief_engineer.value}
                        onChange={handleChange}
                        className="form-control"
                    >
                        <option value="">-- Select Chief Engineer --</option>
                        {state.chief_engineer.options?.map(owner => (
                            <option key={owner.value} value={owner.value}>{owner.label}</option>
                        ))}
                    </select>
                    {state.chief_engineer.error && <div className="invalid-feedback">{state.chief_engineer.error}</div>}

                </div> */}
                {/* <div className="col-md-6 mb-3">
                    <label>Technical Suprintendent {state.technical_supritendent.isRequired && <span className='text-danger'>*</span>}
                    </label>
                    <select
                        name={state.technical_supritendent.name}
                        value={state.technical_supritendent.value}
                        onChange={handleChange}
                        className="form-control"
                    >
                        <option value="">-- Select Technical Suprintendent --</option>
                        {state.technical_supritendent.options?.map(owner => (
                            <option key={owner.value} value={owner.value}>{owner.label}</option>
                        ))}
                    </select>
                    {state.technical_supritendent.error && <div className="invalid-feedback">{state.technical_supritendent.error}</div>}

                </div> */}
                {/* <div className="col-md-6 mb-3">
                    <label>Unit Manager {state.unit_manager.isRequired && <span className='text-danger'>*</span>}
                    </label>
                    <select
                        name={state.unit_manager.name}
                        value={state.unit_manager.value}
                        onChange={handleChange}
                        className="form-control"
                    >
                        <option value="">-- Select Unit Manager --</option>
                        {state.unit_manager.options?.map(owner => (
                            <option key={owner.value} value={owner.value}>{owner.label}</option>
                        ))}
                    </select>
                    {state.unit_manager.error && <div className="invalid-feedback">{state.unit_manager.error}</div>}

                </div> */}

                <div className="col-md-6 mb-3">
                    <label>Keel Laying Date {state.buildDate.isRequired && <span className='text-danger'>*</span>}</label>
                    <input
                        type="date"
                        name={state.buildDate.name}
                        value={state.buildDate.value}
                        onChange={handleChange}
                        className={`form-control ${state.buildDate.error ? 'is-invalid' : ''}`}
                    />
                    {state.buildDate.error && <div className="invalid-feedback">{state.buildDate.error}</div>}
                </div>

                <div className="col-md-6 mb-3">
                    <label>Delivery Date {state.deliveryDate.isRequired && <span className='text-danger'>*</span>}</label>
                    <input
                        type="date"
                        name={state.deliveryDate.name}
                        value={state.deliveryDate.value}
                        onChange={handleChange}
                        className={`form-control ${state.deliveryDate.error ? 'is-invalid' : ''}`}
                    />
                    {state.deliveryDate.error && <div className="invalid-feedback">{state.deliveryDate.error}</div>}
                </div>

                <div className="col-md-6 mb-3">
                    <label>Project {state.projectId.isRequired && <span className='text-danger'>*</span>}</label>
                    <select
                        name={state.projectId.name}
                        value={state.projectId.value}
                        onChange={handleChange}
                        className="form-control"
                    >
                        <option value="">-- Select Project --</option>
                        {state.projectId.options?.map(project => (
                            <option key={project.value} value={project.value}>{project.label}</option>
                        ))}
                    </select>
                    {state.projectId.error && <div className="invalid-feedback">{state.projectId.error}</div>}

                </div>

                <div className="col-md-6 mb-3">
                    <label>Ship Owner {state.shipOwnerId.isRequired && <span className='text-danger'>*</span>}</label>
                    <select
                        name={state.shipOwnerId.name}
                        value={state.shipOwnerId.value}
                        onChange={handleChange}
                        className="form-control"
                    >
                        <option value="">-- Select Ship Owner --</option>
                        {state.shipOwnerId.options?.map(owner => (
                            <option key={owner.value} value={owner.value}>{owner.label}</option>
                        ))}
                    </select>
                    {state.shipOwnerId.error && <div className="invalid-feedback">{state.shipOwnerId.error}</div>}

                </div>

                <div className="col-md-6 mb-3">
                    <label>Yard {state.yardId.isRequired && <span className='text-danger'>*</span>}</label>
                    <select
                        name={state.yardId.name}
                        value={state.yardId.value}
                        onChange={handleChange}
                        className="form-control"
                    >
                        <option value="">-- Select Yard --</option>
                        {state.yardId.options?.map(yard => (
                            <option key={yard.value} value={yard.value}>{yard.label}</option>
                        ))}
                    </select>
                    {state.yardId.error && <div className="invalid-feedback">{state.yardId.error}</div>}

                </div>

                <div className="col-md-12 mb-3">
                    <label>Note {state.note.isRequired && <span className='text-danger'>*</span>}</label>
                    <textarea
                        name={state.note.name}
                        value={state.note.value}
                        onChange={handleChange}
                        className="form-control"
                        rows="3"
                        placeholder="Enter any additional note"
                    />
                </div>

                <div className="col-md-4 form-check ms-2">
                    <input
                        type="checkbox"
                        name={state.isActive.name}
                        checked={state.isActive.value}
                        onChange={handleChange}
                        className="form-check-input"
                        id="isActive"
                    />
                    <label className="form-check-label" htmlFor="isActive">Active</label>
                </div>
            </div>

            <div className="mt-3">
                <button type="submit" className="btn btn-success me-2">Save</button>
                <a className="btn btn-danger text-white"  href={constant.Authedcomponent.listShipMasterData.url}>Cancel</a>

            </div>
        </form>
    );
};

export default ShipForm;
